import React from "react";

/**
 * The right-hand proof column on sign in / create account (aits-2.0
 * `.auth-proof-col`). Static marketing content, verbatim from the design —
 * a labelled sample score card, a real attributed testimonial, and the
 * scan count. Hidden below 900px, where `AuthMiniQuote` stands in.
 *
 * Memoised: it takes no props and never changes, but it is a sibling of the
 * sign-in / create-account forms, so without this it re-renders on every
 * keystroke in those fields.
 */
function AuthProof() {
    return (
        <aside className="auth-proof-col" aria-label="What's waiting inside">
            <div className="auth-eyebrow">What's waiting inside</div>

            <div className="auth-proof-card">
                <div className="score-head">
                    <div className="score-label">
                        <span className="auth-eyebrow">AI Trust Signal Score</span>
                        <span className="score-sub">Sample result · Duncan &amp; Associates</span>
                    </div>
                    {/* The mock's `.badge-status.urgent` is the solid amber
                        "Issue" treatment, which is exactly `.vb-pill--issue`
                        from AITS-487 — reuse it rather than a second badge. */}
                    <span className="vb-pill vb-pill--issue">Unverified</span>
                </div>

                <div className="score-num">
                    <span className="n">42</span>
                    <span className="of">/100</span>
                </div>

                <div className="score-track" role="img" aria-label="Score 42 out of 100">
                    <span className="fill" />
                </div>

                <div className="score-tiles">
                    <div className="tile tile--fail">
                        <span className="n">4</span>
                        <span className="t">Urgent fixes</span>
                    </div>
                    <div className="tile tile--warn">
                        <span className="n">7</span>
                        <span className="t">Worth a look</span>
                    </div>
                    <div className="tile tile--pass">
                        <span className="n">8</span>
                        <span className="t">Already good</span>
                    </div>
                </div>
            </div>

            <div className="auth-proof-card auth-proof-card--quote">
                <p>
                    "Your work on AI Trust Signals gives leaders a measurable way to see where
                    they stand and where they are vulnerable. I will be running our own score,
                    and I will be encouraging my clients to do the same."
                </p>
                <div className="who-row">
                    <img className="av" src="/testimonial-paul.png" alt="" width={40} height={40} />
                    <div className="who">
                        <span className="name">Paul Wallis</span>
                        <span className="role">Managing Director, Hantec Systems</span>
                    </div>
                </div>
            </div>

            <div className="auth-scan-count">
                Over <strong>10,000</strong> businesses scanned so far.
            </div>
        </aside>
    );
}

/** The phone stand-in for the proof column — one condensed pull quote. */
export function AuthMiniQuote() {
    return (
        <div className="auth-panel auth-mini-quote m-only">
            <p>
                "AI Trust Signals gives leaders a measurable way to see where they stand and
                where they are vulnerable."
            </p>
            <span className="who">Paul Wallis · Hantec Systems</span>
        </div>
    );
}

export default React.memo(AuthProof);
